var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useEffect } from 'react';
import { Modal, Table, Button } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import api from '@/api';
const GroupSelectionModal = ({ visible, onOk, onCancel, initialSelectedGroup, currentRecord, projectTech, }) => {
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [dataList, setdataList] = useState([]); // 用于存储接口返回的数据
    useEffect(() => {
        if (initialSelectedGroup) {
            setSelectedRowKeys([initialSelectedGroup.code]); // 使用 code 作为 key
            setSelectedGroup(initialSelectedGroup);
        }
        else {
            setSelectedRowKeys([]);
            setSelectedGroup(null);
        }
        // 定义条件变量
        const isHybridOrReqHY = ((currentRecord === null || currentRecord === void 0 ? void 0 : currentRecord.part) === 'HYBRID' || (currentRecord === null || currentRecord === void 0 ? void 0 : currentRecord.part) === 'ReqHY');
        const isNotAcro = ((currentRecord === null || currentRecord === void 0 ? void 0 : currentRecord.part) !== 'ACRO');
        const isDuetEventPhaseType1 = (projectTech.indexOf('DUET') >= 0);
        // 只有在满足显示表格的条件时才调用接口
        if (visible && !(isHybridOrReqHY || isNotAcro || isDuetEventPhaseType1)) {
            const getBaseMarkOptions = () => __awaiter(void 0, void 0, void 0, function* () {
                const res = yield api.CoachCardApi.getBaseMarkOptions();
                if (res.data && res.data.code === 200) {
                    const clearOption = { key: 'clear', description: '--clear--', code: '', baseMark: undefined }; // 明确类型并设置 code
                    setdataList([clearOption, ...res.data.data]); // 添加空值项
                }
            });
            getBaseMarkOptions();
        }
        else {
            setdataList([]); // 如果不满足条件，清空 dataList
        }
    }, [initialSelectedGroup, visible, currentRecord, projectTech]);
    const columns = [
        {
            title: '',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: '',
            dataIndex: 'code',
            key: 'code',
        },
        {
            title: '',
            dataIndex: 'baseMark',
            key: 'baseMark',
        },
    ];
    const rowSelection = {
        type: 'radio',
        selectedRowKeys,
        onChange: (keys, selectedRows) => {
            setSelectedRowKeys(keys);
            setSelectedGroup(selectedRows.length > 0 ? selectedRows[0] : null);
        },
    };
    const handleOk = () => {
        onOk(selectedGroup);
    };
    const handleCancel = () => {
        onCancel();
    };
    // 定义条件变量
    const isHybridOrReqHY = ((currentRecord === null || currentRecord === void 0 ? void 0 : currentRecord.part) === 'HYBRID' || (currentRecord === null || currentRecord === void 0 ? void 0 : currentRecord.part) === 'ReqHY');
    const isNotAcro = ((currentRecord === null || currentRecord === void 0 ? void 0 : currentRecord.part) !== 'ACRO');
    const isDuetEventPhaseType1 = (projectTech.indexOf('DUET') >= 0);
    return (<Modal title="Select Group" open={visible} onOk={handleOk} onCancel={handleCancel} width="50%" bodyStyle={{ minHeight: '40vh', maxHeight: '60vh', overflowY: 'auto' }} footer={[
            <Button key="cancel" onClick={handleCancel} icon={<CloseOutlined />}>
          Cancel
        </Button>,
            <Button key="ok" type="primary" onClick={handleOk} icon={<CheckOutlined />}>
          OK
        </Button>,
        ]}>
      {/* 不同的弹框内容 */}
      {isHybridOrReqHY && (<div style={{ textAlign: 'center' }}>
          <p>The Base Mark for all Hybrids is 0.50</p>
        </div>)}
      {isNotAcro && (<div style={{ textAlign: 'center' }}>
          <p>Sorry, Base Marks only apply to Acrobatics</p>
        </div>)}
      {isDuetEventPhaseType1 && (<div style={{ textAlign: 'center' }}>
          <p>The Base Mark for all types of Pair Acrobatics is 0.10</p>
        </div>)}
      {/* 其他情况url = "{:url('/MgDataCollectionArtisticSwimming/showBaseMarkSelector')}?part=" + part + "&eventphase_type1=" + eventPhaseType1;调用接口返回显示列表数据 */}
      {!(isHybridOrReqHY || isNotAcro || isDuetEventPhaseType1) && (<Table rowKey="code" // 明确指定 rowKey 为 code
         rowSelection={rowSelection} columns={columns} dataSource={dataList} // 使用接口返回的数据
         pagination={false} bordered size="small" onRow={(record) => {
                return {
                    onClick: () => {
                        setSelectedRowKeys([record.code]); // 使用 record.code
                        setSelectedGroup(record);
                    },
                };
            }}/>)}
    </Modal>);
};
export default GroupSelectionModal;
